import { ApiButton, Box, Button, Typography } from 'web-library';
import React, { useEffect } from 'react';
import { MutationStatus } from 'react-query';
import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { UploadedFile } from 'web-library/models/UploadedFile';
import { useGetWithdrawalDraftDateTime } from '../../api/candidate/exam/@candidate/queries-services/queries';
import DraftTimeStamp from '../../components/DraftTimeStamp';

const useStyles = makeStyles()((theme) =>
({
  buttonArea: {
    marginTop: theme.spacing(4),
  },
  errString: {
    color: theme.color.state.stateError,
  },
  buttonContainer: {
    display: 'flex',
  },
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
}));

interface WithdrawalReasonButtonsProps {
  files: UploadedFile[];
  apiButtonStatus: MutationStatus;
  textArea: string | undefined;
  selectReason: string | undefined;
  displayErrors: boolean;
  setDisplayErrors: (displayErrors: boolean) => void;
  formErrors?: string[];
  setFormErrors: (formErrors: string[]) => void;
  handleBack: () => void;
  handleConfirm: () => void;
  isNonNational?: boolean;
  isFileRejected?: boolean;
  fileRejectedErrorMessage?: string;
}

const WithdrawalReasonButtons = ({
  files,
  apiButtonStatus,
  textArea,
  selectReason,
  displayErrors,
  setDisplayErrors,
  formErrors,
  setFormErrors,
  handleBack,
  handleConfirm,
  isFileRejected,
  fileRejectedErrorMessage,
  isNonNational = false,
}: WithdrawalReasonButtonsProps) => {
  const { classes } = useStyles();

  const { data: timestampData } = useGetWithdrawalDraftDateTime(isNonNational);

useEffect(() => {
  setFormErrors([]);
}, [selectReason, files, textArea, setFormErrors]);

  return (
    <Box className={classes.buttonArea}>
      {displayErrors &&
        formErrors?.map((formError) => (
          <Typography key={formError} variant="body2" className={classes.errString}>
            {formError}
          </Typography>
        ))}
        {isFileRejected && fileRejectedErrorMessage && (
          <Typography variant="body2" className={classes.errString}>
            {fileRejectedErrorMessage}
          </Typography>
         )}
      <Box className={classes.buttonContainer}>
        <Button
          id="button-backWithdrawer"
          className={classes.button}
          type="button"
          color="secondary"
          variant="outlined"
          onClick={handleBack}
        >
          Back
        </Button>

        <ApiButton
          id="button-reviewDetails"
          className={classes.button}
          variant="contained"
          status={apiButtonStatus}
          onClick={handleConfirm}
        >
          Review Details
        </ApiButton>
      </Box>

      {!isNonNational && timestampData && <DraftTimeStamp savedAt={timestampData} />}
    </Box>
  );
};

export default WithdrawalReasonButtons;
